module.exports = "/_next/static/images/7f09c53e15e789d5d28933b932642095-hourglass.svg";